export default "__VITE_ASSET__CtdIYiK$__"